const aspectRatio = 1.25;

const margin = 0.1;

const precise = false;

const canvasSizeFallback = { x: 1920, y: 1080 };

export default {
  aspectRatio,
  margin,
  precise,
  canvasSizeFallback
};
